import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

import AdminLayout from './components/layout/AdminLayout';
import DashboardPage from './pages/dashboard/DashboardPage';
import TenantsListPage from './pages/tenants/TenantsListPage';
import TenantDetailPage from './pages/tenants/TenantDetailPage';
import TenantFeaturesPage from './pages/features/TenantFeaturesPage';
import TenantUsersPage from './pages/users/TenantUsersPage';
import MonitoringPage from './pages/monitoring/MonitoringPage';
import TrialSettingsPage from './pages/settings/TrialSettingsPage';
import FeatureLimitsPage from './pages/settings/FeatureLimitsPage';
import DnsSetupPage from './pages/platform/DnsSetupPage';
import SocialProvidersPage from './pages/settings/SocialProvidersPage';
import SalesSettingsPage from './pages/settings/SalesSettingsPage';
import AdvancedSettingsPage from './pages/settings/AdvancedSettingsPage';
import AdminProfilePage from './pages/profile/AdminProfilePage';
import AdminUsersPage from './pages/users/AdminUsersPage';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_ADMIN_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_ADMIN_USER_POOL_CLIENT_ID,
      loginWith: { email: true },
    },
  },
});

const theme = createTheme({
  palette: {
    primary: { main: '#1565c0' },
    secondary: { main: '#c62828' },
    background: { default: '#f5f5f5' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiPaper: { defaultProps: { elevation: 0 } },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Authenticator hideSignUp={true} variation="modal">
        {({ signOut, user }) => (
          <BrowserRouter>
            <AdminLayout onSignOut={signOut} user={user}>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/tenants" element={<TenantsListPage />} />
                <Route path="/tenants/:tenantId" element={<TenantDetailPage />} />
                <Route path="/tenants/:tenantId/features" element={<TenantFeaturesPage />} />
                <Route path="/tenants/:tenantId/users" element={<TenantUsersPage />} />
                <Route path="/monitoring" element={<MonitoringPage />} />
                <Route path="/settings/trial" element={<TrialSettingsPage />} />
                <Route path="/settings/feature-limits" element={<FeatureLimitsPage />} />
                <Route path="/settings/social-providers" element={<SocialProvidersPage />} />
                <Route path="/settings/sales" element={<SalesSettingsPage />} />
                <Route path="/settings/advanced" element={<AdvancedSettingsPage />} />
                <Route path="/platform/dns" element={<DnsSetupPage />} />
                <Route path="/profile" element={<AdminProfilePage />} />
                <Route path="/admin-users" element={<AdminUsersPage />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </AdminLayout>
          </BrowserRouter>
        )}
      </Authenticator>
    </ThemeProvider>
  );
}
